// Route-scoped lock: wraps the financial routes. While the PIN lock is
// engaged it renders a content-area LockScreen in place of the page, so the
// financial page never mounts (no data fetching) yet the surrounding nav
// stays usable and the user can navigate to unlocked sections.
import { Outlet } from 'react-router-dom';
import { useLockStore } from '@/stores/lockStore';
import { LockScreen } from './LockScreen';

export function FinancialLockGate() {
  const isLocked = useLockStore((s) => s.isLocked);
  if (isLocked) {
    return <LockScreen fullscreen={false} />;
  }
  return <Outlet />;
}
